import 'typeface-roboto'

import React from 'react'
import reactDom from 'react-dom'

import App from './App/App'

// import { register } from './serviceWorker/serviceWorker'
// register()

reactDom.render(<App />, document.getElementById('root'))
